export enum PartyType {

    Company = 'Company',
    Customer = 'Customer',
    Driver = 'Driver',
    Shipper = 'Shipper',
    Employee = 'Employee',
    Broker = 'Broker',
    Laborer = 'Laborer',
    FreightForwarder = 'FreightForwarder',
    CustomsClearanceAgent = 'CustomsClearanceAgent',
    TransportationAgency = 'TransportationAgency'

}

